'use strict';

angular.module('paizacloudApp')
  .directive('containerSplitPane', function($timeout) {
    return {
      templateUrl: 'app/containerSplitPane/containerSplitPane.html',
      restrict: 'EA',
      scope: {
        container: '=',
        controller: '=',
        onRemove: '&',
        windowModels: '=',
      },
      link: function(scope, element, attrs) {
        $timeout(function(){
          let subs = element.find('containertabwm');
          scope.subHeights = subs.toArray().map((sub:any) => sub.offsetHeight);
        }, 0);
        scope.onDividerMove = function(event){
          console.log('onDividerMove', event);
          scope.$broadcast('resize', event);
        };
      },
    };
  });
